import React, { Fragment, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import BackComponent from '../../../../components/BackComponent'
import Label from '../../../helpers/Label'
import Card from '../../../helpers/Card'
import Input from '../../../helpers/Input'
import LinkButton from '../../../helpers/LinkButton'
import Loader from '../../../Common/Loader'
import Validation from '../../../helpers/Validation'
import { ArrowCircleLeft2 } from 'iconsax-react'
import CancelButton from '../../../helpers/CancelButton'
import SaveButton from '../../../helpers/SaveButton'
import flasher from '@flasher/flasher'
import { ClearInfo } from '../../../../Encapsulation/Utils'
import { GetGAAProjectJobTitle, SaveGAAProjectJobTitle } from '../../../../Encapsulation/HotelDomainEntities/Hotel Master/GAAProjectJobTitle'
import { GetGAAProjectDepartment } from '../../../../Encapsulation/HotelDomainEntities/Hotel Master/GAAProjectDepartment'


function GAAProjectJobTitleAddEdit({Rights}) {
  let formMode = "New";
  let { id } = useParams();
  {
    if (id) {
      document.title = "Gladiance - Edit Project Job Title";
      formMode = "Edit";
    } else {
      document.title = "Gladiance - Add Project Job Title";
    }
  }
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const Navigation = useNavigate();
  const Location = useLocation()
  console.log('Location :', Location);
  const [formInfo, setFormInfo] = useState({});

  const handleChange = (e) => {
    setFormInfo((formInfo) => ({
      ...formInfo,
      [e.target.name]: e.target.value,
    }));
  };

// Save Form //
  const handleSubmit = async (e) => {
    e.preventDefault();
    let result = await SaveGAAProjectJobTitle(id, formInfo, []);
    if (result.Successful == false) {
      flasher.warning(result.Message);
    } else {
      flasher.success("Data Added Successfully");
      if (formMode == "Edit") {
        Navigation("/project-job-title-master");
      } else {
        setFormInfo(ClearInfo(formInfo));
        fetchGladianceDepartment()
      }
    }
  };
 
    // Fetch Department From Master Component Dropdown //
  const fetchGladianceDepartment = async () => {
    let department = await GetGAAProjectDepartment(Location.state);
    setFormInfo(formInfo => ({
      ...formInfo,
      GAAProjectDepartmentRef: department.Ref,
      GAAProjectDepartmentName : department.Name
    }))
  };
    // Update / Edit Data Using id //
  const fetchJobTitle = async () => {
    let data = await GetGAAProjectJobTitle(id)
    setFormInfo(data);
}

  useEffect(() => {
    if (Location.state) {
      fetchGladianceDepartment();
    }
    if(id)
    {          
      fetchJobTitle();
    }
  }, []);

  return (
    <Fragment>
      {loader ? (
        <Loader />
      ) : (
        <BackComponent
          title={id ? "Edit Project Job Title" : "Add Project Job Title"}
          button={
            <LinkButton to={"/project-job-title-master"}>
              <ArrowCircleLeft2
                variant="Bold"
                className="w-5 h-5 text-default-color"
              />
            </LinkButton>
          }
        >
          <div className="flex items-center justify-center">
            <Card className={"w-full p-6"}>
              <form onSubmit={(e) => handleSubmit(e)}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <Label htmlFor={"GAAProjectDepartmentRef"} labelText={"Department Name"} />
                    {formInfo.GAAProjectDepartmentRef && (<Input
                      id={"GAAProjectDepartmentRef"}
                      type={"text"}
                      name={"GAAProjectDepartmentRef"}
                      value={formInfo.GAAProjectDepartmentName}
                      required={true}
                      readOnly={true}
                    />
                    )}
                    <Validation error={errors.Address} />
                  </div>
                  <div>
                    <Label htmlFor={"Name"} labelText={"Name"} />
                    <Input
                      id={"Name"}
                      type={"text"}
                      name={"Name"}
                      value={formInfo.Name}
                      inputFocus={true}
                      onChange={handleChange}
                      required={true}
                      readOnly={!Rights.Edit}

                    />
                    <Validation error={errors.Name} />
                  </div>
                </div>
                <div className="flex gap-8 justify-center mt-6">
                  <CancelButton to={"/project-job-title-master"} />
                  {
                    Rights.Edit && <SaveButton text="Save" />
                  }
                </div>
              </form>
            </Card>
          </div>
        </BackComponent>
      )}
    </Fragment>
  );
}


export default GAAProjectJobTitleAddEdit
